// extracted by mini-css-extract-plugin
export default {"colors":"\"../../../styles/variables/colors.module.css\"","color-blue300":"#516681","button":"CookiePreferencesButton_button__WobDC"};